export const SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW = '/pointofsaledisplay-service/point-of-sale-display/slideshow';
export const SOFTLINE_API_POS_DISPLAY_LOCKED_SLIDE_SHOW =
  '/pointofsaledisplay-service/point-of-sale-display/locked/slideshow';
export const SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW_IMAGE = '/pointofsaledisplay-service/point-of-sale-display/slideshow/image/{{key}}';
